module.exports = "/_next/static/files/12971cd144dbc868e1e00002c81aca5b.svg";